// v2/components/Toast.js — bildirim yigini
import React from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import styles from './Toast.module.css';

const ICONS = {
  error: AlertCircle,
  info: Info,
  success: CheckCircle2,
};

export default function ToastStack({ items = [], onDismiss }) {
  if (!items.length) return null;

  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      {items.map((t) => {
        const Icon = ICONS[t.type] || CheckCircle2;
        const cls = t.type === 'error' ? styles.error
          : t.type === 'info' ? styles.info : '';
        return (
          <div key={t.id} className={`${styles.toast} ${cls}`}>
            <span className={styles.icon}><Icon size={16} /></span>
            <span className={styles.msg}>{t.message}</span>
            {onDismiss && (
              <button
                type="button" className={styles.close}
                onClick={() => onDismiss(t.id)}
                aria-label="Bildirimi kapat"
              >
                <X size={13} />
              </button>
            )}
            <span
              className={styles.bar}
              style={{ animationDuration: `${t.duration || 2600}ms`, width: '100%' }}
            />
          </div>
        );
      })}
    </div>
  );
}
